/*
 * @Description: 首页
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-10-10 16:10:58
 * @LastEditors: WangYuhan
 */

import { get, post, put, deleted, prefix } from './base';

// 首页信息
export function home(params) {
  return get(`${prefix}homeV2`, params);
}

// 首页企业列表
export function homeList(params) {
  return get(`${prefix}home/company/list`, params);
}

// ETC支付信息
export function commitTransactionETC(val) {
  return post(`${prefix}waybillSettlement/commitTransactionETC`, val);
}

// 油款支付信息
export function commitTransactionOIl(val) {
  return post(`${prefix}waybillSettlement/v2/commitTransactionOIl`, val);
}

// 查询当前集团销售
export function saler(params) {
  return get(`${prefix}group/saler`, params);
}

// 获取机器人二维码
export function robotQrCode(params) {
  return get(`${prefix}weChatRobot/robotQrCode`, params);
}

export function warning(params) {
  return get(`${prefix}oil/warning`, params);
}

// 查询当前用户通知
export function listDisplayableNotifications(params) {
  return get(`${prefix}employeeUser/listDisplayableNotifications`, params);
}

// 查询当前用户通知
export function acknowledgedNotification(params) {
  return get(`${prefix}employeeUser/acknowledgedNotification`, params);
}
